import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import type { ArticlePage } from '../../../../generated/frontend'
import { Brightcove } from '../../../../shared/components/Brightcove/Brightcove'
import { HeroImage } from '../../../../shared/components/HeroImage/HeroImage'
import { Vimeo } from '../../../../shared/components/Vimeo/Vimeo'
import { YouTube } from '../../../../shared/components/Youtube/YouTube'
import styles from './ArticleHero.module.scss'

export const ArticleHero: FunctionComponent<Props> = ({ heroImage, heroVideo, showPromoBlock }) => {
  if (!heroVideo && !heroImage) {
    return null
  }

  const className = classnames(showPromoBlock && styles.compact)

  if (heroVideo) {
    return (
      <div className={classnames(styles.articleHeroWrapper, className)}>
        {getVideoComponent(heroVideo, heroImage, className)}
      </div>
    )
  }

  return <HeroImage {...heroImage} className={className} />
}

///////// IMPLEMENTATION /////////

type Props = {
  heroImage: ArticlePage['heroImage']
  heroVideo?: ArticlePage['heroVideo']
  showPromoBlock?: boolean
}

const getVideoComponent = (
  heroVideo: ArticlePage['heroVideo'],
  heroImage: ArticlePage['heroImage'],
  className?: string
) => {
  switch (heroVideo.videoClient) {
    case 'brightcove':
      return (
        <Brightcove
          videoId={heroVideo.videoId}
          accountId={heroVideo.brightcoveAccountId}
          playlist={false}
        />
      )
    case 'youtube':
      return <YouTube videoId={heroVideo.videoId} />
    case 'vimeo':
      return <Vimeo videoId={heroVideo.videoId} />
    default:
      return <HeroImage {...heroImage} className={className} />
  }
}
